import { render, staticRenderFns } from "./AdminPromotion.vue?vue&type=template&id=355a5cd2&scoped=true&"
import script from "./AdminPromotion.vue?vue&type=script&lang=js&"
export * from "./AdminPromotion.vue?vue&type=script&lang=js&"
import style0 from "./AdminPromotion.vue?vue&type=style&index=0&id=355a5cd2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355a5cd2",
  null
  
)

export default component.exports